export default __webpack_public_path__ + "static/media/Logo-Merchant.35cb7a76.svg";